import { z } from "zod";
import { displayNameSchema, emailSchema, passwordSchema } from "./userSchema";
import { agreementSignatureSchema } from "./agreementSchema";
import { accountTokenSchema } from "./fields";

/** Completing an invitation: name, password, and the User Agreement signature in one step. */
export const acceptInviteSchema = agreementSignatureSchema.extend({
  token: accountTokenSchema,
  displayName: displayNameSchema,
  password: passwordSchema,
});
export type AcceptInvite = z.infer<typeof acceptInviteSchema>;

export const requestPasswordResetSchema = z.object({ email: emailSchema });

export const resetPasswordSchema = z.object({
  token: accountTokenSchema,
  password: passwordSchema,
});
export type ResetPassword = z.infer<typeof resetPasswordSchema>;

/** What the invitation page can show before the person signs up. */
export const invitePreviewSchema = z.discriminatedUnion("valid", [
  z.object({ valid: z.literal(true), email: z.string() }),
  z.object({ valid: z.literal(false) }),
]);
export type InvitePreview = z.infer<typeof invitePreviewSchema>;
